import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrganizationContext } from "@/lib/context/OrganizationContext";

interface OrganizationInvite {
  id: number;
  invite_token: string;
  invitee_email: string;
  invited_role: string;
  status: string;
  expires_at: string;
  created_at: string;
  user_profiles: {
    first_name: string;
    last_name: string;
  };
}

export function useOrganizationInvites() {
  const { currentOrganization } = useOrganizationContext();

  return useQuery({
    queryKey: ["organization-invites", currentOrganization?.id],
    queryFn: async () => {
      if (!currentOrganization) return [];

      const { data, error } = await supabase
        .from("organization_invites")
        .select(
          `
          id,
          invite_token,
          invitee_email,
          invited_role,
          status,
          expires_at,
          created_at,
          user_profiles!organization_invites_created_by_fkey(
            first_name,
            last_name
          )
        `
        )
        .eq("org_id", currentOrganization.id)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching organization invites:", error);
        throw new Error("Failed to load organization invites");
      }

      return (data || []) as OrganizationInvite[];
    },
    enabled: !!currentOrganization,
    staleTime: 30 * 1000, // 30 seconds
  });
}
